export default "__VITE_ASSET__Kc2bjA_7__"